import React, { FC, memo, useEffect, useState } from "../../../../lib/teact/teact";
import { formatDateToString } from "../../../../util/dateFormat";
import Button from "../../../ui/Button";
import { LotScreenSettings } from "../../config/uiconfig";
import { updateWorkDate } from "../../redux/global";
import ReportApi from "../../restapi/reportApi";
import worker from "../../setupWorker";
import store from "../../store";
import Loading from "../../ui/loading";
import LotSelect from "../../ui/lotSelect";
import { getCurDate, getDateString } from "../../utils/DateTimeUtils";
import { tienFormat } from "../../utils/NumberUtils";
import './baoCaoLaiLoNgay.scss'
type OwnProps = {
    backToScreen: number;
    onChangeScreen: (screen: LotScreenSettings) => void;
}

const BaoCaoLaiLoNgay: FC<OwnProps> = ({
    backToScreen,
    onChangeScreen,
}) => {
    const [state, setState] = useState({
        ngay: store.getState().global.workDate, //getDateString(getCurDate())
        tuNgay: store.getState().global.workDate,
        data: {},// là 1 map, key= contact_id
        isLoading: false,
        dataSaved: 0,
        loaiCongNo: "LaiLo" as "LaiLo" | "Lai" | "Lo",
    })
    useEffect(() => {
        setState(prev => ({ ...prev, isLoading: true }))
        ReportApi.getBalanceReport({ ngay: state.ngay }).then(result => {
            let daLuuCongNo = 0;
            if (result.dataEx && result.dataEx.daLuuCongNo != undefined) {
                daLuuCongNo = result.dataEx.daLuuCongNo
            }
            setState(prev => ({ ...prev, data: result.data, isLoading: false, dataSaved: daLuuCongNo }))
        })
    }, [state.ngay])
    let totalLaiLo = 0
    let totalMb = 0
    let totalMt = 0
    let totalMn = 0
    function renderData() {
        return (
            <div className="balance-container">
                <table className="balance-table">
                    <tr className="balance-header">
                        <td className="balance-name">Tên khách</td>
                        <td>M.Bắc</td>
                        <td>M.Trung</td>
                        <td>M.Nam</td>
                        <td>Lãi/Lỗ</td>
                    </tr>
                    {

                        Object.keys(state.data)?.map((contactId) => {

                            const item: any = state.data[contactId]

                            if (state.loaiCongNo == "Lai" && item.laiLo <= 0) {
                                return <tr key={"lailo-" + contactId}><td colSpan={5}></td></tr>
                            }
                            if (state.loaiCongNo == "Lo" && item.laiLo >= 0) {
                                return <tr key={"lailo-" + contactId}><td colSpan={5}></td></tr>
                            }
                            const cls = item.laiLo >= 0 ? " lai" : " lo"
                            totalLaiLo += item.laiLo;
                            totalMb += item.mienBac;
                            totalMt += item.mienTrung;
                            totalMn += item.mienNam;
                            return (<tr key={"lailo-" + contactId}>
                                <td className="balance-name">{item.name}</td>
                                <td className={"balance-money " + (item.mienBac >= 0 ? " lai" : " lo")}>
                                    {tienFormat(item.mienBac, 1)}</td>
                                <td className={"balance-money" + (item.mienTrung >= 0 ? " lai" : " lo")}>
                                    {tienFormat(item.mienTrung, 1)}</td>
                                <td className={"balance-money" + (item.mienNam >= 0 ? " lai" : " lo")}>
                                    {tienFormat(item.mienNam, 1)}</td>
                                <td className={"balance-money" + cls}>
                                    {tienFormat(item.laiLo, 1)}</td>
                            </tr>)
                        })
                    }
                    <tr>
                        <td className="balance-name">{"Cộng"}</td>
                        <td className={"balance-money-total " + (totalMb >= 0 ? " lai" : "lo")}>
                            {tienFormat(totalMb, 1)}
                        </td>
                        <td className={"balance-money-total " + (totalMt >= 0 ? " lai" : "lo")}>
                            {tienFormat(totalMt, 1)}
                        </td>
                        <td className={"balance-money-total " + (totalMn >= 0 ? " lai" : "lo")}>
                            {tienFormat(totalMn, 1)}
                        </td>
                        <td className={"balance-money-total " + (totalLaiLo >= 0 ? " lai" : "lo")}>
                            {tienFormat(totalLaiLo, 1)}
                        </td>
                    </tr>
                </table>
            </div>
        )
    }
    function luuCongNo() {
        const payload = { ngay: state.ngay }
        ReportApi.saveCongNoNgay(payload).then(res => {
            const pl = { type: 'showsnackbar', data: res.responseText }
            worker.postMessage(pl)
        })
    }
    return (
        <div className="form-main sub-form">
            <div className="form-header small">
                <div className="form-header left-panel">
                    <Button round
                        size="default"
                        color="translucent"
                        onClick={luuCongNo}
                    >
                        <i className={state.dataSaved != 0 ? "fa-regular fa-floppy-disk" : "fa-regular fa-floppy-disk fa-beat fa-xl"}></i>

                    </Button>
                </div>
                <div className="form-header right-panel">
                    {/* <input className=" date-input" type="date" value={state.tuNgay}
                        onChange={(e) => {
                            setState(prev => ({ ...prev, tuNgay: e.target.value }))

                        }}
                    ></input> */}
                    <LotSelect
                        id="LoaiCongNo"
                        value={state.loaiCongNo}
                        onChange={(e) => {
                            setState(prev => ({ ...prev, loaiCongNo: e.target.value as "LaiLo" | "Lai" | "Lo" }))
                        }}
                    >
                        <option value="LaiLo">Lãi/Lỗ</option>
                        <option value="Lai">Lãi</option>
                        <option value="Lo">Lỗ</option>
                    </LotSelect>
                    <input className=" date-input" type="date" value={state.ngay}
                        onChange={(e) => {
                            setState(prev => ({ ...prev, ngay: e.target.value }))
                            store.dispatch(updateWorkDate({ workDate: e.target.value }))
                        }}
                    ></input>
                </div>
            </div>
            <div className="form-content">

                {
                    !state.isLoading ? renderData() : <Loading />
                }

            </div>

        </div>
    )
}

export default memo(BaoCaoLaiLoNgay)